<template>
<fade-transition>
    <div class="c-process-step" :id="'step-' + id">
        <div class="c-process-step__wrapper t-margin-top-s t-margin-right-s t-margin-bottom-s" v-if="number">
            <span class="c-process-step__circle" v-bind:class="{'c-process-step-hide__circle' : this.status === 'Unpublished'}">
			<span class="c-process-step-circle__numbers">{{number}}</span>
            </span>
            <span class="c-process-step__line" v-bind:class="{'c-process-step__hide' : this.status === 'Unpublished'}"></span>
        </div>
        <div class="c-process-step__container c-buffer-box c-buffer-box--border-all t-margin-top-s t-margin-bottom-s" v-bind:class="{'t-background-white-grey t-border-green': mode == 'create' || mode == 'edit', 'c-process-step-hide__border' : this.status === 'Unpublished'}">
            <div class="c-process-step__header">
                <template v-if="mode === 'view'">
                    <div>
                        <h1 class="t-text-style-beta">{{name}}</h1>
                        <can i="manage" :a="processType">
                            <button class="c-button c-button--linkstyle c-button--reset" type="button" @click="goToEditMode">
								<vue-icon name="edit" size="c-icon--17px"></vue-icon>
								<span class="c-button__title">Ändra processteg</span>

							</button>
                        </can>
                    </div>
                </template>
                <div v-if="mode == 'edit'">
                    <h1 class="t-text-style-beta t-margin-bottom-s">Ändra processteg</h1>
                </div>
                <can i="manage" :a="processType">
                    <toggle-status type="process-step" :status="status" :process-id="processId" @publish="publishStep" @unpublish="unpublishStep" v-if="mode === 'edit' || status === 'Unpublished'">
                    </toggle-status>
                </can>
            </div>
            <div v-if="mode === 'view'" class="t-margin-bottom-sm t-margin-top-s s-text s-text--vue" v-html="description"></div>
            <can i="manage" :a="processType">
                <template v-if="mode == 'create' || mode == 'edit'">
                    <h1 class="t-text-style-beta t-margin-bottom-s" v-if="mode == 'create'">Skapa processteg</h1>
                    <form class="c-form" @submit.prevent="handleSubmit">
                        <fieldset>
                            <div class="c-form__item">
                                <vue-input label="Namn på processteg" input-id="name" :value="name" ref="name"></vue-input>
                            </div>
                            <div class="c-form__item">
                                <vue-input label="Beskrivning" input-id="description" :value="description" ref="description" type="textarea"></vue-input>
                            </div>
							<template v-if="mode === 'create'">
							    <button class="c-button c-button--primary t-margin-top-s" type="submit" @click="setSubmitType('create')">Skapa processteg</button>
								<button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelCreateProcessStep">Avbryt</button>
							</template>
							<template v-if="mode === 'edit'">
								<div class="t-space-between">
									<div class="t-margin-bottom-s">
										<button class="c-button c-button--primary" type="submit" @click="setSubmitType('edit')">Spara ändringar</button>
										<button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelEditProcessStep">Avbryt</button>
									</div>
									<button type="submit" class="c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-s" @click="toggleDeleteStepModal">
										<vue-icon name="delete" size="c-icon--17px"></vue-icon>
										<span class="c-button__title">Ta bort processteg</span>
									</button>
								</div>
								<modal :show="showDeleteStepModal" @closeModal="toggleDeleteStepModal">
									<div class="c-modal__content t-background-white t-text-align-center">
										<h1 class="t-text-style-alpha t-margin-bottom-s">Du tar nu bort processteget "{{this.name}}"</h1>
										<form @submit.prevent="handleSubmit" class="c-form">
											<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleDeleteStepModal">Avbryt</button>
											<button class="c-button c-button--primary t-margin-top-s" type="submit" @click="setSubmitType('delete')">Ta bort</button>
										</form>
									</div>
                    			</modal>
							</template>
                        </fieldset>
                    </form>

                </template>
            </can>
            <resources-data-provider
				v-if="mode === 'view'"
				:process-id="processId"
				:process-step-id="id">
                <resources
					:process-id="processId"
					:process-step-id="id"
					slot-scope="dataProvider"
					:show-create="dataProvider.showCreate"
					:resources="dataProvider.resources"
					:process-type="processType"
					@setShowCreate="dataProvider.setShowCreate"
					@createResource="dataProvider.createResource"
					@editResource="dataProvider.editResource"
					@deleteResource="dataProvider.deleteResource"
                    @sortResources="dataProvider.sortResources">
                </resources>
            </resources-data-provider>
        </div>
		<can v-if="mode !== 'create'" i="manage" :a="processType">
			<div class="c-process-step__sorting">
				<form class="c-form" @submit.prevent="handleSubmit">
					<button v-if="sortIndex !== sortIndexes[0]" class="c-button c-button--linkstyle c-button--reset c-process-step__move-up" title="Flytta upp" type="submit" @click="setSubmitType('moveUp')">
						<vue-icon name="expand" size="c-icon--17px"></vue-icon>
					</button>
					<br/>
					<button v-if="sortIndex !== sortIndexes[sortIndexes.length-1]" class="c-button c-button--linkstyle c-button--reset" title="Flytta ner" type="submit" @click="setSubmitType('moveDown')">
						<vue-icon name="expand" size="c-icon--17px"></vue-icon>
					</button>
				</form>
			</div>
		</can>
    </div>
</fade-transition>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import Resources from '@/components/INQ/resources/Resources.vue';
import ResourcesDataProvider from '@/components/INQ/resources-data-provider/ResourcesDataProvider.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
import ToggleStatus from '@/components/INQ/toggle-status/ToggleStatus.vue';
import {
    FadeTransition
} from 'vue2-transitions';
export default {
    name: 'ProcessStep',
    components: {
        VueInput,
        ResourcesDataProvider,
        Resources,
        VueIcon,
        Modal,
        ToggleStatus,
        FadeTransition,
    },
    props: {
        processId: {
            type: String,
            default: '0'
        },
        mode: {
            type: String,
            default: 'view'
        },
        sortIndex: {
            type: Number,
            default: 1
        },
        id: {
            type: String,
            default: '0'
        },
        name: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        status: {
            type: Boolean,
            default: 'Published'
        },
        number: {
            type: String,
            default: ''
        },
        processType: {
            type: String,
			default: ''
		},
		sortIndexes: {
			type: Array,
			default: []
		}
    },
    data: () => ({
        submitType: '',
        showDeleteStepModal: false
    }),
    computed: {
        processStep() {
            if (this.id !== '0') {
                return this.$store.getters['processes/processStep'](this.id);
            } else {
                return {};
            }
        }
    },
    methods: {
        goToCreateMode() {
            this.mode = 'create';
        },
        goToEditMode() {
            this.mode = 'edit';
        },
        goToViewMode() {
            this.mode = 'view';
        },
        setSubmitType(type) {
            this.submitType = type;
        },
        createProcessStep() {
            let name = this.$refs.name.getValue();
            let description = this.$refs.description.getValue();
            this.$emit('createProcessStep', {
                processId: this.processId,
                name: name,
                description: description
            });
        },
        deleteProcessStep() {
			this.$emit('deleteProcessStep', this.id);
			this.goToViewMode();
        },
        editProcessStep() {
            let name = this.$refs.name.getValue();
            let description = this.$refs.description.getValue();
            this.$emit('editProcessStep', {
                id: this.id,
                name: name,
                description: description
            });
            this.goToViewMode();
        },
        cancelCreateProcessStep() {
            this.$emit('clearError');
            this.$emit('toggleShowCreate');
        },
        cancelEditProcessStep() {
            this.$emit('clearError');
            this.goToViewMode();
        },
        publishStep() {
            this.$emit('publish', {
                id: this.id
            });
        },
        unpublishStep() {
            this.$emit('unpublish', {
                id: this.id
            });
        },
		moveUp() {
			this.$emit('sortProcessStep', {
				id: this.id,
				sortIndex: this.sortIndex - 1,
			});
		},
		moveDown() {
			this.$emit('sortProcessStep', {
				id: this.id,
				sortIndex: this.sortIndex + 1,
			});
		},
        handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.createProcessStep();
                    break;
                case 'edit':
                    this.editProcessStep();
                    break;
                case 'delete':
                    this.deleteProcessStep();
                    this.toggleDeleteStepModal();
                    break;
				case 'moveUp':
					this.moveUp();
					break;
				case 'moveDown':
					this.moveDown();
					break;
            }
        },
        toggleDeleteStepModal() {
			this.showDeleteStepModal = !this.showDeleteStepModal;
        },
    }
}
</script>
